import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ name: "MValidationModal", namespaced: true })
export default class MValidationModal extends VuexModule {
  isOpen = false;

  @Mutation
  open() {
    this.isOpen = true;
  }

  @Mutation
  close() {
    this.isOpen = false;
  }

  @Mutation
  set(v: boolean) {
    this.isOpen = v;
  }
}
